(() => {
  'use strict';

  if (window.__esCartLuxeCleanup) {
    try { window.__esCartLuxeCleanup(); } catch (e) {}
  }

  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  const getMoneyFormat = () => {
    return (
      window.money_format ||
      (window.ajaxCartConfig && window.ajaxCartConfig.moneyFormat) ||
      '${{amount}}'
    );
  };

  const formatMoney = (cents) => {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, getMoneyFormat());
      }
    } catch (e) {}
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    return '$' + (n / 100).toFixed(2);
  };

  onReady(() => {
    let cleanupFns = [];
    let recoLoaded = false;
    let fetchController = null;
    let io = null;
    let idleId = null;
    let loadTimer = null;
    let arrowRaf = 0;

    const addCleanup = (fn) => {
      if (typeof fn === 'function') cleanupFns.push(fn);
    };

    const cleanup = () => {
      if (io) {
        try { io.disconnect(); } catch (e) {}
        io = null;
      }
      if (fetchController) {
        try { fetchController.abort(); } catch (e) {}
        fetchController = null;
      }
      if (idleId && 'cancelIdleCallback' in window) {
        try { window.cancelIdleCallback(idleId); } catch (e) {}
      }
      idleId = null;
      if (loadTimer) {
        clearTimeout(loadTimer);
        loadTimer = null;
      }
      if (arrowRaf) {
        try { cancelAnimationFrame(arrowRaf); } catch (e) {}
        arrowRaf = 0;
      }
      while (cleanupFns.length) {
        const fn = cleanupFns.pop();
        try { fn(); } catch (e) {}
      }
    };

    window.__esCartLuxeCleanup = cleanup;

    const getQtyLimitShortMessage = (input) => {
      const rawMax = parseInt(input.getAttribute('data-max-qty') || '', 10);
      const max = Number.isFinite(rawMax) && rawMax >= 0 ? rawMax : null;
      if (max === null) return '';
      return max <= 0 ? 'Currently out of stock' : `Only ${max} available`;
    };

    const setQtyLimitNote = (input, bump = false) => {
      if (!input || !input.closest) return;
      const rowQty = input.closest('.es-cart-row-qty');
      const note = rowQty && rowQty.querySelector('[data-es-qty-limit-note]');
      if (!note) return;
      const rawMax = parseInt(input.getAttribute('data-max-qty') || '', 10);
      const max = Number.isFinite(rawMax) && rawMax >= 0 ? rawMax : null;
      const qty = parseInt(input.value || '0', 10) || 0;
      const show = max !== null && qty >= max;
      if (!show) {
        note.hidden = true;
        note.textContent = '';
        note.classList.remove('is-visible', 'is-bump');
        if (note.__esBumpTimer) clearTimeout(note.__esBumpTimer);
        return;
      }
      note.hidden = false;
      note.textContent = getQtyLimitShortMessage(input);
      note.classList.add('is-visible');
      if (bump) {
        note.classList.remove('is-bump');
        void note.offsetWidth;
        note.classList.add('is-bump');
        if (note.__esBumpTimer) clearTimeout(note.__esBumpTimer);
        note.__esBumpTimer = setTimeout(() => note.classList.remove('is-bump'), 520);
      }
    };

    const onQtyClick = (e) => {
      const btn = e.target.closest('.es-qty-btn');
      if (!btn) return;

      const wrap = btn.closest('.es-qty-control');
      if (!wrap) return;

      const input = wrap.querySelector('input.cart-qty-input');
      if (!input) return;

      const delta = parseInt(btn.getAttribute('data-delta') || '0', 10);
      if (!delta) return;

      const current = parseInt(input.value || '0', 10) || 0;
      const rawMax = parseInt(input.getAttribute('data-max-qty') || '', 10);
      const max = Number.isFinite(rawMax) && rawMax >= 0 ? rawMax : null;
      let next = current + delta;
      if (next < 0) next = 0;
      if (max !== null && next > max) {
        next = max;
        const liveRoot = document.querySelector('.page-cart');
        const live = liveRoot && liveRoot.querySelector('[data-es-cart-live-status]');
        const row = input.closest('tr.cart_item');
        const label = row && row.getAttribute('data-item-label') || 'This item';
        if (live) live.textContent = max <= 0 ? `${label} is currently out of stock.` : `Only ${max} available for ${label}.`;
        setQtyLimitNote(input, true);
      }

      input.value = String(next);
      setQtyLimitNote(input, false);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    document.addEventListener('click', onQtyClick);
    addCleanup(() => document.removeEventListener('click', onQtyClick));

    const bootRecommendations = () => {
      const recoRoot = document.querySelector('[data-es-cart-reco]');
      if (!recoRoot) return;

      const productId = recoRoot.getAttribute('data-product-id');
      const track = recoRoot.querySelector('.es-cart-reco__track');
      const btnPrev = recoRoot.querySelector('.es-ec-carousel__btn.is-prev');
      const btnNext = recoRoot.querySelector('.es-ec-carousel__btn.is-next');

      if (!productId || !track) {
        recoRoot.style.display = 'none';
        return;
      }

      const updateArrows = () => {
        arrowRaf = 0;
        if (!track.isConnected) return;
        if (!btnPrev || !btnNext) return;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const left = track.scrollLeft || 0;

        const needButtons = maxScroll > 20;
        btnPrev.style.display = needButtons ? '' : 'none';
        btnNext.style.display = needButtons ? '' : 'none';

        if (!needButtons) return;
        btnPrev.classList.toggle('is-disabled', left <= 4);
        btnNext.classList.toggle('is-disabled', left >= maxScroll - 4);
      };

      const scheduleArrowUpdate = () => {
        if (arrowRaf) return;
        arrowRaf = window.requestAnimationFrame(updateArrows);
      };

      const scrollByPage = (dir) => {
        const amt = Math.round(track.clientWidth * 0.85) * dir;
        track.scrollBy({ left: amt, behavior: 'smooth' });
        window.setTimeout(scheduleArrowUpdate, 220);
      };

      const onPrev = () => scrollByPage(-1);
      const onNext = () => scrollByPage(1);
      const onScroll = () => scheduleArrowUpdate();
      const onResize = () => scheduleArrowUpdate();

      if (btnPrev) btnPrev.addEventListener('click', onPrev);
      if (btnNext) btnNext.addEventListener('click', onNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);

      addCleanup(() => {
        if (btnPrev) btnPrev.removeEventListener('click', onPrev);
        if (btnNext) btnNext.removeEventListener('click', onNext);
        track.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
      });

      const endpoint = `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=10&intent=related`;

      const loadRecommendations = () => {
        if (recoLoaded) {
          scheduleArrowUpdate();
          return;
        }
        recoLoaded = true;

        if (fetchController) {
          try { fetchController.abort(); } catch (e) {}
        }
        fetchController = 'AbortController' in window ? new AbortController() : null;

        fetch(endpoint, fetchController ? { signal: fetchController.signal } : undefined)
          .then((r) => (r.ok ? r.json() : null))
          .then((data) => {
            if (!data || !Array.isArray(data.products) || data.products.length === 0) {
              recoRoot.style.display = 'none';
              return;
            }

            const products = data.products
              .filter((p) => p && p.available !== false)
              .slice(0, 8);

            if (products.length === 0) {
              recoRoot.style.display = 'none';
              return;
            }

            const escapeHtml = (str) =>
              String(str || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');

            const itemsHtml = products
              .map((p) => {
                const url = p.url || `/products/${p.handle}`;
                const img = p.featured_image || (p.images && p.images[0]) || '';
                const price = typeof p.price === 'number' ? formatMoney(p.price) : '';
                const type = p.type ? escapeHtml(p.type) : 'Eyeshells';
                const title = escapeHtml(p.title);

                return `
                  <div class="es-ec-carousel__item">
                    <div class="es-ec-mini">
                      <a class="es-ec-mini__media" href="${url}">
                        ${img ? `<img src="${img}" alt="${title}" loading="lazy">` : ''}
                      </a>
                      <div class="es-ec-mini__info">
                        <div class="es-ec-mini__type">${type}</div>
                        <a class="es-ec-mini__title" href="${url}">${title}</a>
                        ${price ? `<div class="es-ec-mini__price">${price}</div>` : ''}
                      </div>
                    </div>
                  </div>
                `;
              })
              .join('');

            track.innerHTML = itemsHtml;
            scheduleArrowUpdate();
          })
          .catch((err) => {
            if (err && err.name === 'AbortError') return;
            recoRoot.style.display = 'none';
          })
          .finally(() => {
            fetchController = null;
          });
      };

      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              try { io.disconnect(); } catch (e) {}
              io = null;
              loadRecommendations();
            }
          });
        }, { rootMargin: '320px 0px' });
        io.observe(recoRoot);
      } else if ('requestIdleCallback' in window) {
        idleId = window.requestIdleCallback(loadRecommendations, { timeout: 1200 });
      } else {
        loadTimer = window.setTimeout(loadRecommendations, 180);
      }

      scheduleArrowUpdate();
    };

    bootRecommendations();

    const onPageHide = () => cleanup();
    const onPageShow = () => {
      cleanup();
      cleanupFns = [];
      recoLoaded = false;
      fetchController = null;
      io = null;
      idleId = null;
      loadTimer = null;
      arrowRaf = 0;
      document.addEventListener('click', onQtyClick);
      addCleanup(() => document.removeEventListener('click', onQtyClick));
      bootRecommendations();
    };

    window.addEventListener('pagehide', onPageHide);
    window.addEventListener('pageshow', onPageShow);
    addCleanup(() => window.removeEventListener('pagehide', onPageHide));
    addCleanup(() => window.removeEventListener('pageshow', onPageShow));
  });
})();
